// ContainerForm.jsx
import { UploadCloud, Save, Trash2, X } from "lucide-react";

export default function ContainerForm({ form, handleChange, handleSave, handleDelete, handleUpload, selectedId, uploadProgress, docTypes, onClose }) {
  const input = "bg-white text-navy-900 border border-slate-300 p-2.5 rounded w-full focus:outline-none focus:ring-1 focus:ring-navy-900 focus:border-navy-900 transition-shadow";
  const label = "block text-sm font-semibold text-navy-900 mb-1";

  return (
    <div className="bg-slate-50 p-8 rounded-xl border border-slate-200 shadow-xl mb-8 relative">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-slate-400 hover:text-navy-900"
      >
        <X size={24} />
      </button>

      <h2 className="text-2xl font-bold text-navy-900 mb-6 font-serif">
        {form.id ? "Edit Shipment Details" : "New Shipment Entry"}
      </h2>

      <div className="grid md:grid-cols-2 gap-x-8 gap-y-6">
        {/* Section 1: Core Identifiers */}
        <div className="space-y-4">
          <h3 className="text-sm font-bold text-gold-600 uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">Shipment Info</h3>

          <div>
            <label className={label}>Reference ID / PO Number</label>
            <input className={input} type="text" name="reference" placeholder="e.g. PO-88421" value={form.reference} onChange={handleChange} />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={label}>Origin</label>
              <input className={input} type="text" name="origin" placeholder="HKG" value={form.origin} onChange={handleChange} />
            </div>
            <div>
              <label className={label}>Destination</label>
              <input className={input} type="text" name="destination" placeholder="SYD" value={form.destination} onChange={handleChange} />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={label}>Mode</label>
              <select className={input} name="mode" value={form.mode} onChange={handleChange}>
                <option>Sea</option>
                <option>Air</option>
                <option>Road</option>
              </select>
            </div>
            <div>
              <label className={label}>Container Type</label>
              <select className={input} name="containerType" value={form.containerType} onChange={handleChange}>
                <option>FCL</option>
                <option>LCL</option>
                <option>40HC</option>
                <option>20GP</option>
                <option>Air Freight</option>
              </select>
            </div>
          </div>
        </div>

        {/* Section 2: Dates & Status */}
        <div className="space-y-4">
          <h3 className="text-sm font-bold text-gold-600 uppercase tracking-wider border-b border-slate-200 pb-2 mb-4">Milestones & Status</h3>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={label}>Est. Arrival (ETA)</label>
              <input className={input} type="date" name="eta" value={form.eta} onChange={handleChange} />
            </div>
            <div>
              <label className={label}>Cutoff / Departure</label>
              <input className={input} type="date" name="cutoff" value={form.cutoff} onChange={handleChange} />
            </div>
          </div>

          <div>
            <label className={label}>Incoterms</label>
            <input className={input} type="text" name="incoterms" placeholder="e.g. FOB, CIF" value={form.incoterms} onChange={handleChange} />
          </div>

          <div>
            <label className={label}>Current Status</label>
            <select className={input} name="status" value={form.status} onChange={handleChange}>
              <option>Booked</option>
              <option>WIP</option>
              <option>Dispatched</option>
              <option>In Transit</option>
              <option>Arrived</option>
              <option>Delivered</option>
              <option>Delayed</option>
            </select>
          </div>
        </div>
      </div>

      <div className="mt-8 pt-6 border-t border-slate-200 flex items-center justify-between">
        <div className="flex gap-3">
          <button onClick={handleSave} className="flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white px-6 py-2.5 rounded font-medium transition-colors shadow-sm">
            <Save size={18} />
            {form.id ? "Update Shipment" : "Create Shipment"}
          </button>
          {form.id && (
            <button onClick={() => handleDelete(form.id)} className="flex items-center gap-2 bg-white text-red-600 border border-red-200 hover:bg-red-50 px-4 py-2.5 rounded font-medium transition-colors">
              <Trash2 size={18} />
              Delete
            </button>
          )}
        </div>
      </div>

      {selectedId && (
        <div className="mt-8 bg-blue-50/50 p-6 rounded-lg border border-blue-100">
          <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-4">Attached Documentation</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {docTypes.map((type) => (
              <div key={type} className="bg-white p-4 rounded border border-slate-200 shadow-sm text-center">
                <label className="block mb-3 text-sm font-semibold text-navy-900">{type}</label>
                <div className="relative group cursor-pointer border-2 border-dashed border-slate-300 rounded hover:border-gold-500 transition-colors p-4">
                  <UploadCloud className="mx-auto text-slate-400 group-hover:text-gold-500 mb-2" />
                  <span className="text-xs text-slate-500">Click to Upload</span>
                  <input type="file" onChange={(e) => handleUpload(e, type)} className="absolute inset-0 opacity-0 cursor-pointer" />
                </div>
                {uploadProgress[type] > 0 && (
                  <div className="text-xs mt-2 font-medium text-blue-600 bg-blue-50 py-1 rounded">
                    Uploading: {Math.round(uploadProgress[type])}%
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
